import React from 'react'
import { useBrowserService } from '../../../../lib/hooks'
import { UnsupportedButton } from '../unsupported'
import { InstallType } from '../../../../lib/hooks/install-eligibility'
import { LinkButton, LinkButtonProps } from '../link'
import style from './go.module.scss'

const GoSupportedDownloadButton: React.FC<GoDownloadButtonProps> = (props) => {
  return <LinkButton {...props} />
}

export type GoDownloadButtonProps = Omit<LinkButtonProps, 'onClick'>

export const GoDownloadButton: React.FC<GoDownloadButtonProps> = (props) => {
  const { isMobileOrTablet } = useBrowserService()

  return isMobileOrTablet ? (
    <UnsupportedButton
      {...props}
      alternateLinkInstallTypes={[InstallType.Mac, InstallType.Windows]}
      className={style.goLink}
    />
  ) : (
    <GoSupportedDownloadButton {...props} />
  )
}
